import type { TFunction } from 'i18next';
import type { U2000CriteriaStaticOption, U2000TableColumn } from '../../u2000Core/components/tables/basic/U2000BasicTableList';
import { U2000_CRITERIA_INIT_OPTIONS_U3125_DOCUMENT_NATURES } from '../../u2000Core/components/tables/commons/search/U2000CriteriaInitOptionsRegistry';
import { NS } from '../U3125';
import type { U3125DocumentNatureInitItem, U3125InvoiceTypeNature } from '../U3125Service';

const I18N_KEY_BY_NATURE: Record<U3125InvoiceTypeNature, string> = {
  STANDARD: 'lblDocumentNatureStandard',
  CREDIT: 'lblDocumentNatureCredit',
  ADVANCE: 'lblDocumentNatureAdvance',
  WIP_WRITE_OFF: 'lblDocumentNatureWriteOff',
};

/** Libellé nature : label initLU, sinon i18n, sinon code. */
export function u3125ResolveDocumentNatureLabel(
  code: string | null | undefined,
  documentNatures: U3125DocumentNatureInitItem[] | undefined,
  t: TFunction,
): string {
  const trimmed = String(code ?? '').trim();
  if (!trimmed) return '';
  const fromInit = documentNatures?.find((n) => n.code === trimmed)?.label?.trim();
  if (fromInit) return fromInit;
  const i18nKey = I18N_KEY_BY_NATURE[trimmed as U3125InvoiceTypeNature];
  if (i18nKey) {
    return t(i18nKey, { ns: NS, defaultValue: trimmed });
  }
  return trimmed;
}

/** Options ComboBox critère recherche liste U3125 (initLU.documentNatures — BL-0432). */
export function buildU3125DocumentNatureCriteriaOptions(
  documentNatures: U3125DocumentNatureInitItem[] | undefined,
  t: TFunction,
): U2000CriteriaStaticOption[] {
  if (!documentNatures?.length) return [];
  return documentNatures.map((n) => ({
    value: n.code,
    label: u3125ResolveDocumentNatureLabel(n.code, documentNatures, t),
  }));
}

/** Colonne / critère Nature de document (hors défaut grille — BL-0432). */
export function u3125BuildDocumentNatureListColumn(
  t: TFunction,
  documentNatures: U3125DocumentNatureInitItem[],
): U2000TableColumn {
  return {
    name: 'documentNature',
    label: t('colDocumentNature', { ns: NS }),
    widthClass: 'w-[160px]',
    type: 'string',
    align: 'left',
    isCriteriaField: true,
    inGridField: true,
    isDefaultColumn: false,
    sortable: true,
    isDefaultSortedColumn: false,
    includeConditions: ['equals', 'in'],
    criteriaInitOptions: {
      optionsKey: U2000_CRITERIA_INIT_OPTIONS_U3125_DOCUMENT_NATURES,
      valueKey: 'code',
    },
    display: (_c, value) => u3125ResolveDocumentNatureLabel(String(value ?? ''), documentNatures, t),
  };
}
